import React from 'react';
import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import { WithClassNameProps } from '@front/web-ui/src/components/types';

const PromoLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHighlightText = styled(Text.MDBold)`
  margin-left: 5px;
`;

type ReductionProps = WithClassNameProps & {
  title: string;
  reduction: string;
  label?: string;
};

const Reduction = ({ title, reduction, label, className }: ReductionProps) => (
  <PromoLine className={className}>
    <TitleWrapper>
      <Text>{title}</Text>
      {!!label && <StyledHighlightText color={colors.pink120}>{label}</StyledHighlightText>}
    </TitleWrapper>
    {label ? (
      <Text.SMBold color={colors.pink120}>{`-${reduction}`}</Text.SMBold>
    ) : (
      <Text.SM color={colors.ink50}>{`-${reduction}`}</Text.SM>
    )}
  </PromoLine>
);

export default Reduction;
